export enum ReportJobStatus {
  INITIALIZING = "INITIALIZING",
  QUEUED = "QUEUED",
  STARTED = "STARTED",
  SUCCESS = "SUCCESS",
  ERROR = "ERROR",
}

export const ReportJobStatusColorMap = {
  [ReportJobStatus.INITIALIZING]: "pending",
  [ReportJobStatus.QUEUED]: "approved",
  [ReportJobStatus.STARTED]: "activeColor",
  [ReportJobStatus.SUCCESS]: "successGreen",
  [ReportJobStatus.ERROR]: "errorRed",
};

export const REPORT_JOB_LIST_EXCLUDED_REPORT_SLUGS = [
  "BillingDocumentPdf",
  "EContractPdf",
  "NVDImagesPDFView",
];
